/* eslint arrow-body-style: */
import { saveSelectedLocation as apiSaveSelectedLocation } from 'api/StoreLocation';
import { CLOSE_STORE_MODAL, OPEN_STORE_MODAL, SAVE_SELECTED_LOCATION } from './constants';

/**
 * Close the store modal
 */
const closeStoreModal = () => ({
	type: CLOSE_STORE_MODAL,
});

/**
 * Open the store modal
 */
const openStoreModal = () => ({
	type: OPEN_STORE_MODAL,
});

/**
 * Indicates that we are email the cart.
 * @param {boolean} isSavingStore
 */
const updateSelectedStoreLocation = isSavingStore => ({
	type: SAVE_SELECTED_LOCATION,
	isSavingStore,
});

/**
 * Email cart items in a user's shopping cart.
 * Note: setting the quantity to zero will delete the item.
 * This routine will refetch after the request completes.
 * @param {axios cancel token} cancelToken
 * @param {number} warehouseId integer representing the warehouse id
 * @param {number} currentCustomerId integer representing the customer id
 */
const saveSelectedLocation = (cancelToken, warehouseId, customerId) => {
	return dispatch => {
		return apiSaveSelectedLocation(cancelToken, warehouseId, customerId)
			.then(() => {
				dispatch(updateSelectedStoreLocation(true));
			})
			.catch(error => {
				dispatch(updateSelectedStoreLocation(error));
			});
	};
};

export {
	closeStoreModal,
	openStoreModal,
	saveSelectedLocation,
};
